export default __webpack_public_path__ + "c69e1b5cc10602b237baa010738616d8.svg";